import axios, { AxiosError, AxiosPromise } from 'axios'

interface FailedRequest {
  onSuccess: (token: string) => void
  onFailure: (err: AxiosError) => void
}

const failedRequestsQueue: FailedRequest[] = []

const errorHandler = (error: AxiosError): Promise<AxiosPromise | void> => {
  if (error.response?.status === 403) {
    return new Promise<AxiosPromise>((resolve, reject) => {
      failedRequestsQueue.push({
        onSuccess: (token: string) => {
          if (error.config && error.config.headers) {
            error.config.headers.Authorization = `Bearer ${token}`
          }

          if (error.config) {
            axios(error.config)
              .then((response: any) => {
                resolve(response)
              })
              .catch((err: AxiosError) => {
                reject(err)
              })
          } else {
            reject(new Error('Missing request configuration.'))
          }
        },
        onFailure: (err: AxiosError) => {
          reject(err)
        },
      })
    })
  }

  return Promise.reject(error)
}

export { errorHandler }
